import React, { FC, ReactNode, memo, useCallback } from 'react';

import { FormControlLabel, Typography } from '@mui/material';

import Checkbox from '@components/common/Checkbox';

import useStyles from './styles.module';

interface Props {
  title: string;
  icon?: ReactNode;
  className?: string;
  checked: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const Tag: FC<Props> = ({
  className = '',
  title,
  checked,
  icon,
  disabled = false,
  onClick,
}) => {
  const { classes, cx } = useStyles({ isDisabled: disabled });

  const handleClick = useCallback(() => {
    if (disabled) return;
    onClick();
  }, [disabled, onClick]);

  return (
    <button className={cx(classes.tag, className)} onClick={handleClick}>
      <FormControlLabel
        onClick={handleClick}
        disabled={disabled}
        control={<Checkbox checked={checked} onChange={handleClick} />}
        label={<Typography variant="subtitle2">{title}</Typography>}
      />
      {icon && <span className={classes.icon}>{icon}</span>}
    </button>
  );
};

export default memo(Tag);
